var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import moment from "moment";
import React, { memo, useCallback, useContext, useEffect, useLayoutEffect, useRef, useState, } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useDispatch } from "react-redux";
import { Link, createSearchParams, useNavigate, useSearchParams, } from "react-router-dom";
// import { ReportHeightContext } from "src/contexts/custom-context";
import { isEmpty } from "lodash";
import { ThemeContext } from "src/contexts/theme-context";
import SearchExpiry from "src/pages/search-expiry/search-expiry";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { BANKEX, DEFAULT_OPTION_CHAIN } from "src/utils/constant";
import CommonLtpRenderer from "../../../../src/components/ltp-renderer/common-ltp-renderer";
import Loader from "../../../components/loader/loader";
import { NavPaths } from "../../../config/routes";
import { useAppSelector } from "../../../hooks/redux";
import { openSelectedExpiry } from "../../../redux/reducers/modals";
import { getChangeAndChangePercentageWithoutSign, getDefaultDateFormat, getEnvironmentVariableOrEmpty, getPreferences, setPreferences, } from "../../../utils/methods";
import { unsubscribeDataBySubscriber } from "../../../utils/websocketwrapper";
import FullScreenOCView from "../fullscreen-oc-view/fullscreen-oc-view";
import Backfill from "./../../../components/backfill/backfill";
import DraggableGreeksList from "./draggale-greeks-list";
import OptionChainView1 from "./oc-view1/oc-view1";
import OptionChainView2 from "./oc-view2/oc-view2";
import styles from "./option-chain.module.scss";
import useMaxOiHook from "./useMaxOiHook";
import { SENSEX, EXCHANGE_TYPE_B, EXCHANGE_TYPE_N } from "src/utils/constant";
import FinalGuestLogin from "src/components/final-guest-login/final-guest-login";
// ref forwarding needed here
// For understanding - https://github.com/react-grid-layout/react-grid-layout/issues/1241#issuecomment-859651584
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_ENV } = process.env;
export const OptionChainCompName = "OptionChain";
//let errorMessage: any;
let strikeDiff = 0;
const OptionChain = React.forwardRef((_a, ref) => {
    // const { reportHeightData } = useContext(ReportHeightContext);
    // console.log("OptionChain reportHeightData: ");
    var { isOcIframe, id, isMultiple, position, onVisibilityChange, onAddNewChain, changeHeaderContent, urlSymbol, ocType, 
    // addOcLegData,
    expandedNewTab } = _a, others = __rest(_a, ["isOcIframe", "id", "isMultiple", "position", "onVisibilityChange", "onAddNewChain", "changeHeaderContent", "urlSymbol", "ocType", "expandedNewTab"]);
    // useEffect(() => {
    //    console.log("OptionChain reportHeightData: ", reportHeightData);
    // }, []);
    const navigate = useNavigate();
    const selectedExpiryData = useAppSelector((state) => {
        return state.modals.selectedExpiry;
    });
    const timeoutBuildChainRef = useRef();
    const myPreferences = getPreferences();
    const theme = useContext(ThemeContext);
    // const myPreferences = PREFERENCE_DATA;
    const isFullScreenView = id == "fullscreen-oc";
    let getSelectedScript = DEFAULT_OPTION_CHAIN.selectedScript;
    let getSelectedOptionType = DEFAULT_OPTION_CHAIN.selectedOptionType;
    // let getSelectedExpiry = DEFAULT_OPTION_CHAIN.getSelectedExpiry;
    const [searchParams] = useSearchParams();
    const { expandedFrom } = Object.fromEntries(searchParams);
    if (isFullScreenView && !expandedFrom) {
        if (position == 1) {
            getSelectedScript = myPreferences.optionChain.selected[0].selectedScrip;
            getSelectedOptionType =
                myPreferences.optionChain.selected[0].categorySelected;
            // getSelectedExpiry = myPreferences.optionChain.selected[0].selectedExpiry
            //   ? myPreferences.optionChain.selected[0].selectedExpiry
            //   : "";
        }
        else {
            getSelectedScript = myPreferences.optionChain.selected[1].selectedScrip;
            getSelectedOptionType =
                myPreferences.optionChain.selected[1].categorySelected;
            // getSelectedExpiry = myPreferences.optionChain.selected[1].selectedExpiry
            //   ? myPreferences.optionChain.selected[1].selectedExpiry
            //   : "";
        }
    }
    else {
        getSelectedScript = myPreferences.dashboard.miniOC.selectedScrip;
        getSelectedOptionType =
            expandedFrom && myPreferences.dashboard.miniOC.categorySelected == "OI"
                ? "Price"
                : myPreferences.dashboard.miniOC.categorySelected;
        //getSelectedExpiry = myPreferences.dashboard.miniOC.selectedExpiry;
    }
    const [showDDModal, setShowDDModal] = useState(false);
    const [showSOTModal, setShowSOTModal] = useState(false);
    // const searchRef = useRef<any>();
    const ddRef = useRef();
    const [selectedExpiry, setSelectedExpiry] = useState("");
    const [optionsChain, setOptionsChain] = useState();
    const [optionChainLoading, setOptionChainLoading] = useState(true);
    const [selectedScript, setSelectedScript] = useState(getSelectedScript); //2
    const [isSecondaryView, setIsSecondaryView] = useState(true);
    // const [isPriceChangeNegative, setIsPriceChangeNegative] = useState(false);
    const [strikeLimit, setStrikeLimit] = useState(20);
    const [futExp, setFutExp] = useState("");
    // const tokensData = useRef<SocketDataType[]>([]);
    const [isHoverEnabled, setIsHoverEnabled] = useState(true);
    const [checkboxEnabled, setCheckboxEnabled] = useState(true);
    const spotScripWsData = useRef();
    const [optionsArray, setOptionArray] = useState([]);
    const [errorMessage, seterrorMessage] = useState("");
    //const [expandWindow, setExpandWindow] = useState(false);
    //const currentURL = window.location.href;
    const [selectedStrike, setSelectedStrike] = useState(false);
    // const openFeedWsHeartBeat = useAppSelector(
    //   (state) => state.openFeedWs.heartBeat
    // );
    const futscripWsData = useRef();
    const dispatch = useDispatch();
    // const optionsArray = useRef<OptionChainItem[]>([]);
    const { callMaxOi, putMaxOi } = useMaxOiHook(optionsArray);
    const cutOffPrice = useRef(0);
    const [checkCount, setCheckCount] = useState(0);
    const [hideShowExpiryModal, setHideShowExpiryModal] = useState(false);
    const [lotSize, setLotSize] = useState(0);
    const arrayObj = ["Price"];
    const [initialClick, setInitailClick] = useState(false);
    const [optionChainTypes, setOptionChainTypes] = useState(arrayObj);
    const [selectedOptionType, setSelectedOptionType] = useState(getSelectedOptionType);
    const [showGreeksSetting, setShowGreeksSetting] = useState(false);
    const updateFutPriceAndChange = useCallback((ltp, prevClose) => {
        if (spotScripWsData.current) {
            spotScripWsData.current.LastRate = Number(ltp);
            spotScripWsData.current.PrevClose = Number(prevClose);
        }
    }, []);
    const updateOptionChain = (lastRate, prevClose) => {
        updateFutPriceAndChange(lastRate, prevClose);
        const currentDiff = Math.abs(cutOffPrice.current - lastRate);
        if (optionsArray.length > 10 &&
            (currentDiff > strikeDiff / 2 ||
                isEmpty(optionsChain) ||
                Object.keys(optionsChain).length < 10)) {
            if (!optionChainLoading) {
                // console.log(
                //   "This is a tribute currentDiff:",
                //   currentDiff,
                //   "cutOffPrice.current ",
                //   cutOffPrice.current,
                //   " lastrate",
                //   cutOffPrice.current
                // );
                if (timeoutBuildChainRef.current == undefined) {
                    timeoutBuildChainRef.current = setTimeout(() => {
                        //TODO useMounted is required here.
                        buildOptionChain(lastRate);
                        timeoutBuildChainRef.current = undefined;
                    }, 1000);
                }
            }
        }
    };
    // useEffect(() => {
    //   // console.log("THis is a tribute currentDiff:");
    // }, [optionsArray, optionsChain]);
    useEffect(() => {
        if (urlSymbol) {
            setSelectedScript(urlSymbol);
        }
    }, [urlSymbol]);
    const onGreekSettingClick = (e) => {
        // e.preventDefault();
        // setInitailClick(true);
        // setShowGreeksSetting((showGreeksSetting) => !showGreeksSetting);
        if (optionsChain) {
            if (initialClick) {
                setInitailClick(false);
            }
            else
                setShowGreeksSetting((showGreeksSetting) => !showGreeksSetting);
        }
    };
    const buildOptionChain = (lastRate) => {
        const socketData = [];
        let index = 0;
        let prev = 0;
        let cutOffPriceLocal = 0;
        optionsArray.forEach((obj, i) => {
            if (cutOffPriceLocal >= lastRate) {
            }
            else {
                prev = cutOffPriceLocal;
                cutOffPriceLocal = obj.StrikeRate;
                index = i;
            }
        });
        if (Math.abs(cutOffPriceLocal - lastRate) >= Math.abs(prev - lastRate)) {
            cutOffPriceLocal = prev;
            index = index - 1;
        }
        cutOffPrice.current = cutOffPriceLocal;
        if (index < 0) {
            index = 0;
        }
        // console.log(cutOffPrice.current, " cutOffPrice.current final");
        //console.log(JSON.stringify(optionsArray.current[localCutOffIndex]));
        // will be needed in future
        const startIndex = 0;
        const endIndex = optionsArray.length;
        if (optionsArray.length) {
            const chain = {};
            optionsArray.slice(startIndex, endIndex).map((o) => {
                if (!chain[o.StrikeRate]) {
                    chain[o.StrikeRate] = {
                        PE: { isChecked: false },
                        CE: { isChecked: false },
                    };
                }
                const oiChange = getChangeAndChangePercentageWithoutSign(o.OpenInterest, o.Prev_OI);
                if (o.CPType === "PE") {
                    chain[o.StrikeRate].PE = {
                        OI: Number(o.OpenInterest),
                        LTP: Number(o.LastRate),
                        OI_CHANGE: oiChange,
                        LAST_RATE: Number(o.LastRate),
                        PREVIOUS_CLOSE: Number(o.PreviousClose),
                        PREV_OI: Number(o.Prev_OI),
                        SCRIPT_CODE: Number(o.ScripCode),
                        EXCH: o.EXCH,
                        EXCH_TYPE: o.ExchType,
                        NAME: o.Name,
                        isChecked: false,
                        TOTAL_QTY: Number(o.Volume),
                    };
                    // Set CE only if it doesn't exist
                    if (!chain[o.StrikeRate].CE.OI) {
                        chain[o.StrikeRate].CE = {
                            OI: 0,
                            LTP: 0,
                            OI_CHANGE: "0",
                            LAST_RATE: 0,
                            PREVIOUS_CLOSE: 0,
                            PREV_OI: 0,
                            SCRIPT_CODE: o.ScripCode,
                            EXCH: o.EXCH,
                            EXCH_TYPE: o.ExchType,
                            NAME: o.Name,
                            isChecked: false,
                            TOTAL_QTY: 0,
                        };
                    }
                }
                if (o.CPType === "CE") {
                    chain[o.StrikeRate].CE = {
                        OI: Number(o.OpenInterest),
                        LTP: Number(o.LastRate),
                        OI_CHANGE: oiChange,
                        LAST_RATE: Number(o.LastRate),
                        PREVIOUS_CLOSE: Number(o.PreviousClose),
                        PREV_OI: Number(o.Prev_OI),
                        SCRIPT_CODE: Number(o.ScripCode),
                        EXCH: o.EXCH,
                        EXCH_TYPE: o.ExchType,
                        NAME: o.Name,
                        isChecked: false,
                        TOTAL_QTY: Number(o.Volume),
                    };
                    // Set PE only if it doesn't exist
                    if (!chain[o.StrikeRate].PE.OI) {
                        chain[o.StrikeRate].PE = {
                            OI: 0,
                            LTP: 0,
                            OI_CHANGE: "0",
                            LAST_RATE: 0,
                            PREVIOUS_CLOSE: 0,
                            PREV_OI: 0,
                            SCRIPT_CODE: o.ScripCode,
                            EXCH: o.EXCH,
                            EXCH_TYPE: o.ExchType,
                            NAME: o.Name,
                            isChecked: false,
                            TOTAL_QTY: 0,
                        };
                    }
                }
                socketData.push({
                    Exch: o.EXCH,
                    ExchType: o.ExchType,
                    ScripCode: o.ScripCode,
                });
            });
            const firstStrike = optionsArray[index];
            const secondStrike = index + 2 > endIndex
                ? optionsArray[index - 2]
                : optionsArray[index + 2];
            strikeDiff = Math.abs((secondStrike === null || secondStrike === void 0 ? void 0 : secondStrike.StrikeRate) - (firstStrike === null || firstStrike === void 0 ? void 0 : firstStrike.StrikeRate));
            Object.keys(chain).map((sp) => {
                chain[sp].CE.MAX_OI = callMaxOi;
                chain[sp].PE.MAX_OI = putMaxOi;
            });
            setOptionsChain(chain);
        }
    };
    const fetchOptionsCallback = (nearest, optionsResp, cashScriptdata, futList) => {
        try {
            if (!nearest) {
                return;
            }
            if (optionsResp === undefined ||
                optionsResp === null ||
                optionsResp.length === 0) {
                setOptionArray([]);
                setOptionChainLoading(false);
                return;
            }
            setOptionChainLoading(true);
            const lastRate = cashScriptdata[0].LTP != 0
                ? cashScriptdata[0].LTP
                : futList[0]
                    ? futList[0].LTP
                    : nearest.LTP;
            // const scripCode = nearest.ScripCode;
            // const prevClose = nearest.PClose || 0;
            const expiry = moment(nearest.ExpiryDate).format("MMM DD, YYYY");
            setFutExp(expiry);
            futscripWsData.current = {
                Exch: nearest.Exch,
                ExchType: nearest.ExchType,
                ScripCode: nearest.ScripCode,
                LastRate: nearest.LTP || 0,
                PrevClose: nearest.PreviousClose || 0,
            };
            if (cashScriptdata) {
                spotScripWsData.current = {
                    Exch: cashScriptdata[0].Exch,
                    ExchType: cashScriptdata[0].ExchType,
                    ScripCode: cashScriptdata[0].ScripCode,
                    LastRate: lastRate || 0,
                    PrevClose: cashScriptdata[0].PreviousClose,
                };
            }
            if (optionsResp[0].MktLot) {
                setLotSize(optionsResp[0].MktLot);
            }
            unsubscribeDataBySubscriber(OptionChainCompName + position);
            // if (optionsResp) {
            //   optionsResp.sort((firstItem, secondItem) => {});
            // }
            //debugger;
            setOptionArray(optionsResp);
            // eslint-disable-next-line no-empty
        }
        catch (err) {
            console.error(err);
            setOptionChainLoading(false);
        }
        finally {
        }
    };
    useEffect(() => {
        try {
            if (spotScripWsData.current &&
                spotScripWsData.current.LastRate != undefined) {
                buildOptionChain(spotScripWsData.current.LastRate);
            }
        }
        catch (error) {
            console.error(error);
        }
        if (optionsArray.length > 0) {
            setOptionChainLoading(false);
        }
    }, [optionsArray]);
    useEffect(() => {
        if (optionChainLoading) {
            if (optionsArray.length > 0) {
                setOptionChainLoading(false);
            }
        }
    }, [showGreeksSetting]);
    useEffect(() => {
        if (isEmpty(optionsChain) && !optionChainLoading) {
            seterrorMessage("No Data Found");
        }
        else {
            seterrorMessage(null);
        }
    }, [optionChainLoading]);
    useEffect(() => {
        if (!isOcIframe) {
            return;
        }
        ocType ? changeOptionType(ocType) : changeOptionType("Price");
        const messageEvent = (event) => {
            var _a;
            if ((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) {
                changeOptionType(event.data.type);
            }
            else {
                changeOptionType("Price");
            }
        };
        window.addEventListener("message", messageEvent);
        return () => window.removeEventListener("message", messageEvent);
    }, []);
    // useEffect(()=>{
    //   const myPreferences = getPreferences();
    //   if(!isFullScreenView){
    //     const miniOcPreference = myPreferences.dashboard.miniOC;
    //     console.log(miniOcPreference.categorySelected == selectedOptionType,"=======");
    //     if(miniOcPreference.categorySelected != selectedOptionType){
    //       changeOptionType(miniOcPreference.categorySelected);
    //     }
    //     if(miniOcPreference.selectedScrip != selectedScript ){
    //       onButtonClick(miniOcPreference.selectedScrip);
    //     }
    //     console.log(miniOcPreference,"MyPreferences",isFullScreenView);
    //   }
    // });
    useEffect(() => {
        if (REACT_APP_ENV != "development") {
            if (!isEmpty(optionsChain) && Object.keys(optionsChain).length > 10) {
                const ocString = JSON.stringify(optionsChain || "");
                const optionChainClone = JSON.parse(ocString);
                Object.keys(optionChainClone).forEach((strike) => {
                    const currentObj = optionChainClone[strike];
                    currentObj.CE.MAX_OI = callMaxOi;
                    currentObj.PE.MAX_OI = putMaxOi;
                });
                setOptionsChain(optionChainClone);
            }
        }
    }, [callMaxOi, putMaxOi]);
    const fetchExpiriesListCallback = useCallback((selectedSymbol, expiryResponse) => {
        try {
            if (expiryResponse.length > 0) {
                const prefSaved = getPreferences();
                const setExpiry = isFullScreenView
                    ? position == 1
                        ? prefSaved.optionChain.selected[0].selectedExpiry
                        : prefSaved.optionChain.selected[1].selectedExpiry
                    : prefSaved.dashboard.miniOC.selectedExpiry;
                // if (setExpiry) {
                //   setSelectedExpiry(setExpiry);
                // } else {
                setSelectedExpiry(expiryResponse[0].ExpiryDate); //
                // }
                if (!isFullScreenView) {
                    // myPreferences.dashboard.miniOC.selectedExpiry = expiryResponse[0].ExpiryDate;
                    // setPreferences(myPreferences);
                }
            }
        }
        catch (err) {
            console.error(err);
        }
    }, []);
    const onExpirySelect = useCallback((expiry) => {
        setShowDDModal(false);
        if (expiry) {
            setSelectedExpiry(expiry.target.value);
            const myPreferences = getPreferences();
            // if (!isFullScreenView) {
            //   myPreferences.dashboard.miniOC.selectedExpiry = expiry.target.value;
            // } else if (isFullScreenView && position == 1) {
            //   myPreferences.optionChain.selected[0].selectedExpiry =
            //     expiry.target.value;
            // } else if (isFullScreenView && position == 2) {
            //   myPreferences.optionChain.selected[1].selectedExpiry =
            //     expiry.target.value;
            // }
            setPreferences(myPreferences);
        }
        else {
            setSelectedExpiry("");
            // if(!isFullScreenView){
            // myPreferences.dashboard.miniOC.selectedExpiry ="";
            // setPreferences(myPreferences);}
        }
        if (changeHeaderContent)
            changeHeaderContent(position);
    }, [changeHeaderContent, position]);
    // const onChainUIChange = useCallback((isChecked: boolean) => {
    //   setIsSecondaryView(isChecked);
    // }, []);
    const onSOTClick = (newValue) => {
        setShowSOTModal(newValue);
    };
    const changeOptionType = (value) => {
        setShowSOTModal(false);
        setSelectedOptionType(value);
        if (!isFullScreenView) {
            myPreferences.dashboard.miniOC.categorySelected = value;
        }
        else if (isFullScreenView && position == 1) {
            myPreferences.optionChain.selected[0].categorySelected = value;
        }
        else if (isFullScreenView && position == 2) {
            myPreferences.optionChain.selected[1].categorySelected = value;
        }
        setPreferences(myPreferences);
        if (value == "Straddle") {
            setCheckboxEnabled(false);
            removeSelectedDataUsingPosition(position);
        }
        else if (value === "Price" || value === "Greeks") {
            setCheckboxEnabled(true);
        }
        if (isFullScreenView && value == "OI") {
            navigate({
                pathname: NavPaths.openInterest.index,
            });
        }
        captureCleverTabAnalytics(`Option Chain selected`, {
            eventName: (isFullScreenView ? "Expanded " : "Mini ") +
                `Option Chain - ${value} Selected`,
        });
    };
    // Filtering the Option chain types list. If SENSEX is selected, the Option chain type list will not contain Greeks
    // in the dropdown. For other option chain types dropdown will show Greeks.
    const filteredOptionChainTypes = selectedScript == "SENSEX"
        ? optionChainTypes.filter((type) => type != "Greeks")
        : optionChainTypes;
    const goToOI = () => {
        // selectedScript added in preferance for OI
        navigate({
            pathname: NavPaths.openInterest.oiDashboard,
            search: `?${createSearchParams(selectedScript)}`,
        });
    };
    const onRowSelect = useCallback((e) => {
        if (e.target.value == "all") {
            setSelectedStrike(true);
        }
        else {
            setSelectedStrike(false);
        }
        setStrikeLimit(e.target.value);
    }, [selectedStrike]);
    useEffect(() => {
        if (selectedExpiryData.length > 0) {
            removeSelectedDataUsingPosition(position);
        }
    }, [selectedExpiry]);
    const onButtonClick = (script, data) => {
        setSelectedScript(script);
        if (!isFullScreenView) {
            myPreferences.dashboard.miniOC.selectedScrip = script;
            //myPreferences.dashboard.miniOC.selectedExpiry = "";
        }
        else if (isFullScreenView && position == 1) {
            myPreferences.optionChain.selected[0].selectedScrip = script;
            // myPreferences.optionChain.selected[0].selectedExpiry = "";
        }
        else if (isFullScreenView && position == 2) {
            myPreferences.optionChain.selected[1].selectedScrip = script;
            // myPreferences.optionChain.selected[1].selectedExpiry = "";
        }
        setSelectedExpiry("");
        setPreferences(myPreferences);
        spotScripWsData.current = undefined;
        cutOffPrice.current = 0;
        setOptionArray([]);
        setOptionsChain({});
        setShowDDModal(false);
        // setSearchText("");
        if (changeHeaderContent)
            changeHeaderContent(position);
    };
    useEffect(() => {
        if (selectedScript == "SENSEX" && selectedOptionType == "Greeks") {
            setSelectedOptionType("Price");
        }
    }, [selectedScript]);
    useLayoutEffect(() => {
        if (!isFullScreenView) {
            arrayObj.push("OI");
        }
        arrayObj.push("Straddle");
        arrayObj.push("Greeks");
        // if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
        //   arrayObj.push("Greeks");
        // } else if (REACT_APP_ENV == "production") {
        //   if (!isFullScreenView) {
        //     arrayObj.push("Greeks");
        //   }
        // }
        setOptionChainTypes(arrayObj);
    }, [isMultiple]);
    // useEffect(() => {
    //   if (
    //     selectedScript == "NIFTY" ||
    //     selectedScript == "BANKNIFTY" ||
    //     selectedScript == "FINNIFTY"
    //   ) {
    //     setPlaceholderText("");
    //   } else {
    //     setPlaceholderText(selectedScript);
    //   }
    // }, [selectedScript]);
    // useEffect(() => {
    //   if (openFeedWsMsg) {
    //     updateOptionChain(openFeedWsMsg);
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [openFeedWsMsg]);
    useEffect(() => {
        return () => {
            unsubscribeDataBySubscriber(OptionChainCompName + position);
            // removeSelectedDataUsingPosition(position);
        };
    }, [position]);
    useEffect(() => {
        return () => {
            //unmount cleanup
            ddRef.current = undefined;
            spotScripWsData.current = undefined;
            futscripWsData.current = undefined;
            seterrorMessage(null);
        };
    }, []);
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const checkIfClickedOutside = (e) => {
            if (showDDModal && ddRef.current && !ddRef.current.contains(e.target)) {
                setShowDDModal(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [showDDModal]);
    const ShowHideCheckBox = (checkboxEnabled) => {
        setCheckboxEnabled(!checkboxEnabled);
        if (selectedExpiryData.length > 0 && checkboxEnabled) {
            removeSelectedDataUsingPosition(position);
        }
    };
    const removeSelectedDataUsingPosition = (positonToBeRemoved) => {
        const cloneData = JSON.parse(JSON.stringify(selectedExpiryData));
        const newFilteredData = cloneData.filter((singleElement) => {
            const isSelected = singleElement.position != positonToBeRemoved;
            // if (isSelected) {
            //   singleElement.position = 1;
            // }
            return isSelected;
        });
        dispatch(openSelectedExpiry(newFilteredData));
    };
    // const checkModalBasket = useAppSelector((state) => {
    //   return state.modals.addToBasketPayload;
    // });
    // const hideShowSelectedExpiryModal = (data, flag): void => {
    //   if (data == undefined) {
    //     return;
    //   }
    //   const clonedata = JSON.parse(JSON.stringify(data));
    //   if (clonedata && !flag) {
    //     Object.keys(clonedata).forEach((strike) => {
    //       clonedata[strike]["PE"].isChecked = false;
    //       clonedata[strike]["CE"].isChecked = false;
    //     });
    //     setOptionsChain({ ...clonedata });
    //     setCheckCount(0);
    //   } else {
    //     setHideShowExpiryModal(true);
    //   }
    // };
    // const newArray: any = [];
    //TODO checkbox is this required?
    // useEffect(() => {
    //   if (selectedExpiryData && selectedExpiryData.data)
    //     dispatch(
    //       openSelectedExpiry({
    //         data: selectedExpiryData.data,
    //       })
    //     );
    // }, [selectedExpiryData && selectedExpiryData.data]);
    // useEffect(() => {
    //   //TODO checkbox is this required?
    //   if (selectedExpiryData.length == 0) {
    //     const cloneOptionChain = { ...optionsChain };
    //     Object.keys(cloneOptionChain).forEach((ele, i) => {
    //       cloneOptionChain[ele]["CE"].isChecked = false;
    //       cloneOptionChain[ele]["PE"].isChecked = false;
    //     });
    //     if (cloneOptionChain) setOptionsChain(cloneOptionChain);
    //   } else {
    //   }
    // }, [selectedExpiryData]);
    // const closeSearch = useCallback(() => {
    //   setSearchText("");
    // }, []);
    // console.log(openFeedGreeks);
    const handleClickAddNewButton = () => {
        captureCleverTabAnalytics("Expanded OC - Add new button clicked", {
            eventName: "Expanded OC - Add new button clicked",
        });
    };
    const futLtpRenderCallback = useCallback((ltp, prevLtp, changePercentObj) => {
        return (_jsxs(_Fragment, { children: [_jsxs("span", { children: [ltp, "\u00A0"] }), _jsx("span", Object.assign({ className: parseInt(changePercentObj.differenceValue) > 0
                        ? styles.upStyle
                        : styles.downStyle }, { children: ` (${changePercentObj.differenceValue || "-"})` })), " "] }));
    }, []);
    const renderOC = () => {
        if (optionChainLoading) {
            return _jsx(Loader, {});
        }
        else if (errorMessage) {
            return _jsx(Backfill, { errorMessage: errorMessage });
        }
        else if (isFullScreenView) {
            return (_jsx(_Fragment, { children: _jsx(FullScreenOCView, { isOcIframe: isOcIframe, id: id, optionsChain: optionsChain, limit: strikeLimit, isMultiple: isMultiple, isHoverEnabled: isHoverEnabled, expiry: selectedExpiry, position: position, symbol: selectedScript ? selectedScript : undefined, lotSize: lotSize, checkboxEnabled: isOcIframe || checkboxEnabled, selectedOptionType: selectedOptionType, activeStrike: cutOffPrice.current, spotScripDetails: spotScripWsData.current, expandedNewTab: expandedNewTab
                        ? expandedNewTab
                        : location.pathname == "/option-chain-expanded"
                            ? true
                            : false }) }));
        }
        else if (isSecondaryView && selectedOptionType == "OI") {
            return (_jsx(OptionChainView2, { id: id, optionsChain: optionsChain, symbol: selectedScript ? selectedScript : undefined, isHoverEnabled: isHoverEnabled, expiry: selectedExpiry, position: position, selectedOptionType: selectedOptionType, isMultiple: isMultiple, lotSize: lotSize, activeStrike: cutOffPrice.current, spotScripDetails: spotScripWsData.current }));
        }
        return (
        //Have to work on this component
        _jsx(OptionChainView1, { id: id, optionsChain: optionsChain, isHoverEnabled: isHoverEnabled, symbol: selectedScript ? selectedScript : undefined, expiry: selectedExpiry, position: position, selectedOptionType: selectedOptionType, isMultiple: isMultiple, lotSize: lotSize, activeStrike: cutOffPrice.current, spotScripDetails: spotScripWsData.current }));
    };
    const spotLtpUpdateRenderCall = (_ltp, _prevClose, _changePercentObj, ltpNumber, prevLtpNumber) => {
        if (spotScripWsData.current) {
            updateOptionChain(ltpNumber, prevLtpNumber);
        }
        return _jsx(_Fragment, {});
    };
    const renderInfo = () => {
        var _a, _b;
        // if (currentPage == NavPaths.dashboard) {
        return (_jsxs("div", Object.assign({ className: `mt-3 mb-2 d-flex ${selectedOptionType === "Straddle"
                ? styles.justifyContentStraddle
                : "justify-content-between"}`, id: "middle-Header" }, { children: [selectedOptionType === "Straddle" ? null : (_jsx("span", Object.assign({ className: `${styles.callLTP} mediumWeight medium` }, { children: "Call" }))), !optionChainLoading && (_jsxs("span", Object.assign({ className: `${styles.script} mediumWeight medium` }, { children: [selectedScript, _jsx("span", Object.assign({ className: styles.themeText }, { children: ` FUT ` })), _jsxs("span", { children: [getDefaultDateFormat(futExp) + " ", " \u00A0"] }), _jsx(CommonLtpRenderer, { scripCode: !isOcIframe && futscripWsData.current
                                ? futscripWsData.current.ScripCode
                                : 0, exch: selectedScript.toUpperCase() == SENSEX ||
                                selectedScript.toUpperCase() == BANKEX
                                ? EXCHANGE_TYPE_B
                                : EXCHANGE_TYPE_N, exchType: "D", renderElement: futLtpRenderCallback, ltp: (_a = futscripWsData.current) === null || _a === void 0 ? void 0 : _a.LastRate, prevLtp: (_b = futscripWsData.current) === null || _b === void 0 ? void 0 : _b.PrevClose, componentName: OptionChainCompName + position })] }))), selectedOptionType === "Straddle" ? null : (_jsx("span", Object.assign({ className: `${styles.putLTP} mediumWeight medium` }, { children: "Put" })))] })));
        // }
    };
    const renderNoOfRowsControl = () => {
        if (!isFullScreenView) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs("div", Object.assign({ className: styles.listControlWrapper }, { children: [_jsx("span", { children: "Strikes" }), _jsxs("select", Object.assign({ className: `${styles.ddWrapper} w-auto`, name: "strikes", onChange: (e) => onRowSelect(e) }, { children: [_jsx("option", Object.assign({ value: "10" }, { children: "10" })), _jsx("option", Object.assign({ value: "15" }, { children: "15" })), _jsx("option", Object.assign({ value: "20", selected: strikeLimit == 20 }, { children: "20" })), _jsx("option", Object.assign({ value: "25" }, { children: "25" })), _jsx("option", Object.assign({ value: "all" }, { children: "All" }))] }))] })));
    };
    // console.error(selectedExpiryData, "This is a tribute");
    const renderAddNew = () => {
        if (!isFullScreenView) {
            return _jsx(_Fragment, {});
        }
        if (isMultiple) {
            return (_jsx("div", Object.assign({ className: styles.closeChain }, { children: _jsx("span", { title: "Close", className: "closeIcon", onClick: () => {
                        if (onVisibilityChange && position) {
                            removeSelectedDataUsingPosition(position);
                            onVisibilityChange(position);
                        }
                    } }) })));
        }
        return (_jsxs(_Fragment, { children: [!isOcIframe && (_jsx("div", Object.assign({ className: styles.addNewButton, onClick: () => {
                        // dispatch(setMultipleOptionChain(true));
                        if (onAddNewChain) {
                            onAddNewChain();
                        }
                        handleClickAddNewButton();
                    } }, { children: _jsx("span", { children: "Add New" }) }))), !expandedNewTab && !isOcIframe && (
                // <Link to={"/option-chain-expanded"} target="_blank">
                _jsx(Link, { title: "Expand", to: "/option-chain-expanded", target: "_blank", 
                    // onClick={() =>
                    //  window.open('https://fno-pre.5paisa.com/option-chain-expanded','_blank') }
                    // https://fno-pre.5paisa.com/option-chain-expanded
                    // navigate("/option-chain-expanded")}
                    style: { cursor: "pointer" }, className: "expandIcon ms-2" }))] }));
    };
    const renderHoverToggle = () => {
        if (!isFullScreenView) {
            return _jsx(_Fragment, {});
        }
        return (_jsx("div", { className: styles.hoverContainer }));
    };
    const renderCheckBoxToggle = () => {
        if (!isFullScreenView || isOcIframe) {
            return _jsx(_Fragment, {});
        }
        return (_jsx("div", Object.assign({ className: styles.hoverContainer }, { children: _jsx("div", Object.assign({ className: styles.hover }, { children: (selectedOptionType == "Price" ||
                    selectedOptionType == "Greeks") && (_jsx("div", { className: `${checkboxEnabled ? styles.enabledCheck : styles.disabledCheck}`, onClick: () => ShowHideCheckBox(checkboxEnabled) })) })) })));
    };
    const renderSearchRow = () => {
        return (_jsxs("div", Object.assign({ className: `${styles.actionBar} d-flex flex-column flex-sm-row align-items-sm-center align-items-start justify-content-between`, id: "table-Header" }, { children: [_jsx(SearchExpiry, { isOcIframe: isOcIframe, selectedScript: selectedScript, selectedScriptCallback: (value) => {
                        onButtonClick(value, optionsChain);
                    }, hideFinNifty: false, hideSensex: true, hideMidCpBankex: false, selectedExpiry: selectedExpiry, selectedExpiryCallback: (value) => onExpirySelect(value), expiriesCallback: (symbol, value) => {
                        fetchExpiriesListCallback(symbol, value);
                    }, callSearchFoScripApi: true, callOptionsFromSymbolApi: true, optionsCallback: (values, optionResp, lastCashscriptcode, expList, futList) => fetchOptionsCallback(values, optionResp, lastCashscriptcode, futList), loadingCallback: (value) => setOptionChainLoading(value), triggeredFrom: "miniOC", isMultiple: isMultiple, isFullScreenView: isFullScreenView, refresh: 0 }), isFullScreenView && (_jsxs("div", Object.assign({ className: styles.ocfullScreenItems }, { children: [renderHoverToggle(), renderNoOfRowsControl(), renderAddNew()] })))] })));
    };
    //Write a script to deploy code on azure storage
    // console.log("OptionChain tribute : ", id);
    // OPTION CHAIN RESPONSE LENGTH FOR ALL DROPDOWN
    useEffect(() => {
        const len = Object.keys(optionsChain || {}).length;
        if (selectedStrike) {
            setStrikeLimit(len);
        }
    }, [optionsChain, selectedStrike]);
    return (
    // <Profiler id={"OptionChain" + position} onRender={onRenderCallback}>
    _jsx("div", Object.assign({ ref: ref }, others, { className: id == "small-chain" ? styles.gridBgChain : styles.gridBgDashboard }, { children: _jsxs("div", Object.assign({ className: `${styles.optionChain} ${isOcIframe && styles.ocIframe} d-flex flex-column` }, { children: [_jsxs("div", Object.assign({ className: `${styles.sectionHeader} ${isOcIframe && "py-0"} sectionHeaderExpand ${expandedNewTab && "sectionHeader-expand"}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex flex-grow-1 align-items-center" }, { children: [expandedNewTab && (_jsx("span", { className: ` ordersTab-expand me-2` })), !isOcIframe && (_jsxs("span", Object.assign({ className: `mediumWeight text-uppercase ${styles.sectionTitle}` }, { children: ["Option Chain ", isMultiple ? position : ""] })))] })), isFullScreenView &&
                            // {(REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") &&
                            //   renderGreeksToggle()}
                            renderCheckBoxToggle(), isFullScreenView && !isOcIframe && !expandedNewTab && (_jsx("span", Object.assign({ className: "greyBgTag greyBgTagHover darkGreyText medium px-4 py-1 ms-2 pointer border", onClick: () => goToOI() }, { children: "OI" }))), !isOcIframe && (_jsx(OutsideClickHandler, Object.assign({ onOutsideClick: () => {
                                onSOTClick(false);
                            } }, { children: _jsxs("div", Object.assign({ className: `${styles.ddWrapper} ms-2`, ref: ddRef, onClick: () => {
                                    onSOTClick(!showSOTModal);
                                } }, { children: [_jsx("span", Object.assign({ className: "mediumWeight medium" }, { children: selectedOptionType })), _jsx("img", { className: styles.ddArrow, src: getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
                                            `/fno/assets/${theme.theme == "dark"
                                                ? "images/grey-arrow-dark"
                                                : "svgs/dropdown"}.svg`, alt: "Dropdown-icon" }), showSOTModal && (_jsx("div", Object.assign({ className: styles.ddModal }, { children: filteredOptionChainTypes === null || filteredOptionChainTypes === void 0 ? void 0 : filteredOptionChainTypes.map((type) => {
                                            return (_jsx("div", Object.assign({ className: styles.ddItem, onClick: () => changeOptionType(type) }, { children: _jsx("span", Object.assign({ className: "medium mediumWeight" }, { children: type })) }), type));
                                        }) })))] })) }))), !isFullScreenView && (_jsx(Link, { title: "Expand", to: "/option-chain-expanded?expandedFrom=mini", target: "_blank", style: { cursor: "pointer" }, className: "expandIcon ms-2" })), _jsx(OutsideClickHandler, Object.assign({ onOutsideClick: (event) => {
                                if (showGreeksSetting) {
                                    setShowGreeksSetting(false);
                                    setInitailClick(true);
                                }
                            } }, { children: _jsx("div", { children: showGreeksSetting && (_jsxs("div", Object.assign({ className: `${styles.greeksSettingDD}` }, { children: [_jsx("h6", Object.assign({ className: "p-2 medium mediumWeight" }, { children: "Greeks Customization" })), _jsx(DraggableGreeksList, { isFullScreenView: isFullScreenView, onConfirm: () => {
                                                setShowGreeksSetting(false);
                                                setOptionChainLoading(true);
                                                // Promise.resolve().then(() => setOptionChainLoading(false));
                                            }, position: position, isMultiple: isMultiple })] }))) }) }))] })), _jsxs("div", Object.assign({ className: `${styles.gridLayoutContent} gridLayoutContent ${expandedNewTab && "expandWrapper"} pb-1 d-flex flex-column flex-grow-1` }, { children: [renderSearchRow(), !optionChainLoading && optionsArray.length === 0 ? (_jsx(Backfill, { errorMessage: "No Data Found!" })) : optionsArray.length > 0 ? (selectedOptionType === "Greeks" ? (_jsx("div", Object.assign({ className: "position-relative flex-grow-1" }, { children: _jsx(FinalGuestLogin, { parentClassName: "position-absolute" }) }))) : (_jsxs(_Fragment, { children: [renderInfo(), renderOC()] }))) : (_jsx(Loader, {}))] })), checkCount > 0 && optionsChain && !hideShowExpiryModal && (_jsx(_Fragment, {}))] })) }))
    // </Profiler>
    );
});
OptionChain.displayName = "OptionChain";
export default memo(OptionChain);
